import {CancellationRequestStatusValue} from '../types/cancellationRequest.types'

export const normalizeCancellationRequestStatus = (
  status: string | undefined
): CancellationRequestStatusValue | undefined => {
  const normalizedStatus = status?.toLowerCase()

  if (
    normalizedStatus === 'sent' ||
    normalizedStatus === 'completed' ||
    normalizedStatus === 'failed'
  ) {
    return normalizedStatus
  }

  return undefined
}
